import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faPlus } from '@fortawesome/free-solid-svg-icons';
import BaseURL from '../assets/contants/BaseURL';
import axios from 'axios';
import Header from '../components/header';

const ActualReading = () => {
  const [readings, setReadings] = useState([]);
  const [peakTimings, setPeakTimings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [formData, setFormData] = useState({
    date: '',
    slot_t1: '',
    slot_t2: '',
    slot_t3: '',
    slot_t4: '',
    slot_t5: '',
    slot_t: ''
  });
  const itemsPerPage = 10;
  const [currentSlot, setCurrentSlot] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredReadings, setFilteredReadings] = useState([]);

  useEffect(() => {
    fetchPeakTimings();
    fetchReadings();
  }, []);

  useEffect(() => {
    if (searchTerm === '') {
      setFilteredReadings(readings);
    } else {
      const filtered = readings.filter(reading => 
        reading.date.toLowerCase().includes(searchTerm.toLowerCase()) ||
        reading.slot_t1.toString().includes(searchTerm) ||
        reading.slot_t2.toString().includes(searchTerm) ||
        reading.slot_t3.toString().includes(searchTerm) ||
        reading.slot_t4.toString().includes(searchTerm) ||
        reading.slot_t5.toString().includes(searchTerm) ||
        reading.slot_t.toString().includes(searchTerm)
      );
      setFilteredReadings(filtered);
    }
    setCurrentPage(1);
  }, [searchTerm, readings]);

  const fetchReadings = async () => {
    try {
      const response = await axios.get(`${BaseURL}meters/actual-reading/`);
      setReadings(response.data);
      setFilteredReadings(response.data);
      setLoading(false);
    } catch (err) {
      alert('Error Fetching Data');
      setLoading(false);
    }
  };

  const totalPages = Math.ceil(filteredReadings.length / itemsPerPage);

  const paginatedData = filteredReadings.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BaseURL}meters/actual-reading/`, formData);
      setShowModal(false);
      setFormData({
        date: '',
        slot_t1: '',
        slot_t2: '',
        slot_t3: '',
        slot_t4: '',
        slot_t5: '',
        slot_t: ''
      });
      setSuccessMessage('Successfully added Actual Reading')
      setTimeout(() => setSuccessMessage(''), 3000);
      fetchReadings();
    } catch (err) {
      if (err.response && err.response.status === 400) {
        alert('Error: A reading for this date already exists');
      } else {
        alert(`Error: ${err.message}`);
      }
    }
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${BaseURL}meters/actual-reading/${formData.id}/`, formData);
      setShowUpdateModal(false);
      setFormData({
        id: '',
        date: '',
        slot_t1: '',
        slot_t2: '',
        slot_t3: '',
        slot_t4: '',
        slot_t5: '',
        slot_t: ''
      });
      setSuccessMessage('Successfully updated Actual Reading')
      setTimeout(() => setSuccessMessage(''), 3000);
      fetchReadings();
    } catch (err) {
      alert('Error updating Data');
    }
  };

  const handleSlotClick = (reading, slotName) => {
    setCurrentSlot(slotName);
    setFormData({
      id: reading.id,
      date: reading.date,
      slot_t1: reading.slot_t1,
      slot_t2: reading.slot_t2,
      slot_t3: reading.slot_t3,
      slot_t4: reading.slot_t4,
      slot_t5: reading.slot_t5,
      slot_t: reading.slot_t
    });
    setShowUpdateModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const fetchPeakTimings = async () => {
    try {
      const response = await axios.get(`${BaseURL}meters/peaktimings/`);
      setPeakTimings(response.data);
    } catch (err) {
      console.error('Error fetching peak timings:', err);
    }
  };

  const getTimingForSlot = (slot) => {
    if (slot === 'T') return '12AM to 12PM';
    const timingObj = peakTimings.find(t => t.slots === slot);
    return timingObj ? timingObj.timing : '';
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '20px' }}>Loading...</div>;
  }

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <div style={{
        backgroundColor: '#007acc',
        color: 'white',
        alignContent: 'center',
        fontSize: '14px',
        height: '40px'
      }}>
        <Header title="TOD GRID READINGS" />
      </div>

      <div style={{
        border: '1px solid #ccc',
        padding: '10px',
        marginTop: '20px',
        boxShadow: '0 2px 8px rgba(0, 0,  0, 0.1)',
        backgroundColor: 'white',
        margin: '20px auto',
        maxWidth: '1000px',
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', width: '30%' }}>
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{
                padding: '8px',
                border: '1px solid #ccc',
                borderRadius: '8px',
                flex: '1',
                marginRight: '10px',
              }}
            />
            <FontAwesomeIcon
              icon={faSearch}
              style={{ color: '#007acc', cursor: 'pointer' }}
            />
          </div>

          <div style={{ marginLeft: 'auto' }}>
            <button
              onClick={() => setShowModal(true)}
              style={{
                padding: '10px 15px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                marginRight: '10px',
              }}
            >
              <FontAwesomeIcon icon={faPlus} style={{ marginRight: '5px' }} />
              Add
            </button>
          </div>
        </div>
      </div>

      <div style={{ textAlign: 'center', margin: '20px 0' }}>
                {successMessage && (
                    <div style={{
                        padding: '10px',
                        borderRadius: '5px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        margin: '10px auto',
                        width: 'fit-content',
                    }}>
                        {successMessage}
                    </div>
                )}
            </div>

      <div style={{
        marginTop: '20px',
        padding: '10px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
        maxWidth: '1000px',
        margin: '20px auto',
        marginBottom: '70px',
      }}>
        <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
          <thead style={{ backgroundColor: '#007acc', color: 'white' }}>
            <tr>
              <th style={{ padding: '10px' }}>S.No</th>
              <th style={{ padding: '10px' }}>Date</th>
              <th style={{ padding: '10px' }}>
                T1 <span style={{ fontWeight: 'normal' }}>({getTimingForSlot('T1')})</span>
              </th>
              <th style={{ padding: '10px' }}>
                T2 <span style={{ fontWeight: 'normal' }}>({getTimingForSlot('T2')})</span>
              </th>
              <th style={{ padding: '10px' }}>
                T3 <span style={{ fontWeight: 'normal' }}>({getTimingForSlot('T3')})</span>
              </th>
              <th style={{ padding: '10px' }}>
                T4 <span style={{ fontWeight: 'normal' }}>({getTimingForSlot('T4')})</span>
              </th>
              <th style={{ padding: '10px' }}>
                T5 <span style={{ fontWeight: 'normal' }}>({getTimingForSlot('T5')})</span>
              </th>
              <th style={{ padding: '10px' }}>
                Total Hours (12AM to 12PM)
              </th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((reading, index) => (
                <tr
                  key={reading.id}
                  style={{
                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9f9f9',
                  }}
                >
                  <td style={{ padding: '10px' }}>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td style={{ padding: '10px' }}>{reading.date}</td>
                  <td 
                    style={{ padding: '10px', cursor: 'pointer', textAlign: 'center' }}
                    onClick={() => handleSlotClick(reading, 'slot_t1')}
                  >
                    {reading.slot_t1}
                  </td>
                  <td 
                    style={{ padding: '10px', cursor: 'pointer', textAlign: 'center' }}
                    onClick={() => handleSlotClick(reading, 'slot_t2')}
                  >
                    {reading.slot_t2}
                  </td>
                  <td 
                    style={{ padding: '10px', cursor: 'pointer', textAlign: 'center' }}
                    onClick={() => handleSlotClick(reading, 'slot_t3')}
                  >
                    {reading.slot_t3}
                  </td>
                  <td 
                    style={{ padding: '10px', cursor: 'pointer', textAlign: 'center' }}
                    onClick={() => handleSlotClick(reading, 'slot_t4')}
                  >
                    {reading.slot_t4}
                  </td>
                  <td 
                    style={{ padding: '10px', cursor: 'pointer', textAlign: 'center' }}
                    onClick={() => handleSlotClick(reading, 'slot_t5')}
                  >
                    {reading.slot_t5}
                  </td>
                  <td 
                    style={{ padding: '10px', cursor: 'pointer', textAlign: 'center' }}
                    onClick={() => handleSlotClick(reading, 'slot_t')}
                  >
                    {reading.slot_t}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ padding: '10px', textAlign: 'center' }}>
                  No readings found.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            style={{
              margin: "0 5px",
              padding: "5px 10px",
              background: currentPage === 1 ? "#ddd" : "#007acc",
              color: "#ffffff",
              border: "none",
              borderRadius: "25px",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            Previous
          </button>

          {[...Array(totalPages).keys()].map((_, i) => (
            <button
              key={i + 1}
              onClick={() => handlePageChange(i + 1)}
              style={{
                margin: "0 5px",
                padding: "5px 10px",
                background: currentPage === i + 1 ? "#007acc" : "#ddd",
                color: currentPage === i + 1 ? "#ffffff" : "#333",
                border: "1px solid #ddd",
                borderRadius: "25px",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            style={{
              margin: "0 5px",
              padding: "5px 10px",
              background: currentPage === totalPages ? "#ddd" : "#007acc",
              color: "#ffffff",
              border: "none",
              borderRadius: "25px",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            Next
          </button>
        </div>
      </div>
      {showModal && (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <div style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              width: '90%',
              maxWidth: '600px',
              maxHeight: '80vh',
              overflowY: 'auto',
            }}>

            <h4 style={{ marginBottom: '20px', textAlign: 'center' }}>Add New Actual Reading</h4>
            
            <form onSubmit={handleSubmit}>
                <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <label style={{ marginBottom: '5px' }}>
                        Date <span style={{ color: 'red' }}>*</span>
                        </label>
                        <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleInputChange}
                            required
                            style={{
                            width: '93%',
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            }}
                        />
                    </div>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <label style={{ marginBottom: '5px' }}>
                        T1 <span style={{ fontWeight: 'normal' }}>({getTimingForSlot('T1')})</span>
                        </label>
                        <input
                        type="number"
                        step="0.01"
                        name="slot_t1"
                        value={formData.slot_t1}
                        onChange={handleInputChange}
                        required
                        style={{
                            width: '93%',
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                        }}
                        />
                    </div>
                </div>

                <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <label style={{ marginBottom: '5px' }}>
                        T2 <span style={{ fontWeight: 'normal' }}>({getTimingForSlot('T2')})</span>
                        </label>
                        <input
                            type="number"
                            step="0.01"
                            name="slot_t2"
                            value={formData.slot_t2}
                            onChange={handleInputChange}
                            required
                            style={{
                            width: '93%',
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            }}
                        />
                    </div>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <label style={{ marginBottom: '5px' }}>
                        T3 <span style={{ fontWeight: 'normal' }}>({getTimingForSlot('T3')})</span>
                        </label>
                        <input
                        type="number"
                        step="0.01"
                        name="slot_t3"
                        value={formData.slot_t3}
                        onChange={handleInputChange}
                        required
                        style={{
                            width: '93%',
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                        }}
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <label style={{ marginBottom: '5px' }}>
                        T4 <span style={{ fontWeight: 'normal' }}>({getTimingForSlot('T4')})</span>
                        </label>
                        <input
                            type="number"
                            step="0.01"
                            name="slot_t4"
                            value={formData.slot_t4}
                            onChange={handleInputChange}
                            required
                            style={{
                            width: '93%',
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            }}
                        />
                    </div>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <label style={{ marginBottom: '5px' }}>
                        T5 <span style={{ fontWeight: 'normal' }}>({getTimingForSlot('T5')})</span>
                        </label>
                        <input
                        type="number"
                        step="0.01"
                        name="slot_t5"
                        value={formData.slot_t5}
                        onChange={handleInputChange}
                        required
                        style={{
                            width: '93%',
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                        }}
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '20px', marginBottom: '15px' }}>
                    <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                        <label style={{ marginBottom: '5px' }}>
                        Total Hours (12AM to 12PM)
                        </label>
                        <input
                        type="number"
                        step="0.01"
                        name="slot_t"
                        value={formData.slot_t}
                        onChange={handleInputChange}
                        required
                        style={{
                            width: '93%',
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                        }}
                        />
                    </div>
                </div>

                <div style={{ 
                display: 'flex', 
                justifyContent: 'center',
                gap: '10px'
                }}>
              <button
                type="submit"
                style={{
                    padding: '8px 16px',
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    minWidth: '100px'
                    }}
              >
                Add Energy
              </button>
              <button
                onClick={() => {
                  setShowModal(false);
                  setFormData({
                    date: '',
                    slot_t1: '',
                    slot_t2: '',
                    slot_t3: '',
                    slot_t4: '',
                    slot_t5: '',
                    slot_t: ''
                  });
                }}
                style={{
                    padding: '8px 16px',
                    backgroundColor: '#f44336',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    minWidth: '100px'
                    }}
              >
                Cancel
              </button>
            </div>
            </form>
            </div>
        </div>
        )}
        {showUpdateModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
          }}>
            <div style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '600px',
            }}>
              <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>
                Update {currentSlot === 'slot_t' ? 'Total Hours' : currentSlot.replace('slot_', '').toUpperCase()}
                <span style={{ fontWeight: 'normal', marginLeft: '5px' }}>
                  ({currentSlot === 'slot_t' ? '12AM to 12PM' : getTimingForSlot(currentSlot.replace('slot_', '').toUpperCase())})
                </span>
              </h2>
              <form onSubmit={handleUpdateSubmit}>
                <div style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: '20px',
                  marginBottom: '20px'
                }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Date:</label>
                    <input
                      type="date"
                      name="date"
                      value={formData.date}
                      onChange={handleInputChange}
                      style={{ 
                        width: '93%', 
                        padding: '8px', 
                        borderRadius: '4px', 
                        border: '1px solid #ccc' 
                      }}
                      disabled
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ display: 'block', marginBottom: '5px' }}>
                      {currentSlot === 'slot_t' ? 'Total Hours' : currentSlot.replace('slot_', '').toUpperCase()} 
                      <span style={{ fontWeight: 'normal', marginLeft: '5px' }}>
                        ({currentSlot === 'slot_t' ? '12AM to 12PM' : getTimingForSlot(currentSlot.replace('slot_', '').toUpperCase())})
                      </span>:
                    </label>
                    <input
                      type="number"
                      name={currentSlot}
                      value={formData[currentSlot]}
                      onChange={handleInputChange}
                      style={{ 
                        width: '93%', 
                        padding: '8px', 
                        borderRadius: '4px', 
                        border: '1px solid #ccc' 
                      }}
                      required
                    />
                  </div>
                </div>
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center',
                  gap: '10px'
                }}>
                  <button
                    type="submit"
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#4CAF50',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      minWidth: '100px'
                    }}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setShowUpdateModal(false);
                      setFormData({
                        id: '',
                        date: '',
                        slot_t1: '',
                        slot_t2: '',
                        slot_t3: '',
                        slot_t4: '',
                        slot_t5: '',
                        slot_t: ''
                      });
                    }}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#f44336',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      minWidth: '100px'
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
    </div>
  );
};

export default ActualReading;